<template>
  <div class="container">
    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow :title="$t('Operation.analyse.comparaison')" :params="{operationId: operationId}" routeBack="OperationShow" :sub-title-ope="operationName"/>
      <div class="row mx-0 ml-auto align-items-center">
        <b-button v-if="simulationId" variant="outline-primary" @click="goToSimulation">
          {{ $t('See') + ' ' + $t('l.e') + ' ' + $t('simulation') }}
        </b-button>
      </div>
    </div>

    <div class="mt-4">
      <b-table id="table-charges" ref="table"
               :fields="tableFields"
               :items="itemsCharges"
               :tbody-tr-class="rowClass"
               :thead-class="'row-header'"
               borderless
               responsive="sm"
               class="light-border"
               striped>

        <template #[`head(${field.key})`]="{ label }" v-for="field in tableFields">
          <div @click="toggleExtraFieldsCharges(field.key)" class="cursor-pointer label-primary d-flex" v-if="label && (!label.startsWith('TTC') && !label.startsWith('HT') && !label.startsWith('Différence'))"  :key="field.key">
            <div style="line-height: 2.2">{{ label }}</div>
            <caret-down-icon v-if="!field.isDetailVisible" />
            <caret-up-icon v-if="field.isDetailVisible" />
          </div>
          <span v-else class="label-primary" style="line-height: 2.2">
             {{ label }}
          </span>
        </template>


        <template #cell(type)="data">
          <span v-if="data.value && data.value.includes('(Loué)')">
            {{ $t(data.value.replace('(Loué)', '')) }} <span class="loue-color">(Loué)</span>
          </span>
          <span v-else>
            {{ $t(data.value) }}
          </span>
        </template>
        <template #cell(simulation)="data">
          <template v-if="data.value === '-'"> {{ data.value }}</template>
          <template v-else-if="data.value!==''"> {{ data.value === 0 ? '-' : data.value + ' €' }}</template>
        </template>
        <template #cell(AVP)="data">
          <template v-if="data.value === '-'"> {{ data.value}}</template>
          <template v-else-if="data.value!==''">
            <div v-if="data.item.isCombined">
              <div class="combined-line">
                {{ getMainValue(data.item, 'AVP') }}
              </div>
              <div class="combined-details">
                <div v-for="(op, index) in getFilteredDetails(data.item, 'AVP')" :key="'op-'+index">
                  {{ op.ttc }}€ - {{ op.name }}
                </div>
              </div>
            </div>
            <span v-else>
              {{ data.value === 0 ? '-' : data.value + ' €' }}
            </span>
          </template>
        </template>
        <template #cell()="data">
          <template v-if="data.value === '-'"> {{ data.value }}</template>
          <template v-else-if="data.value!==''"> {{ data.value + " €" }}</template>
          <template v-else-if="!data.value && !data.item.hasOwnProperty('status')"> {{ "-" }}</template>
          <template v-else-if="!data.value && data.item.hasOwnProperty('status') && data.item.status==='total-primary'"> {{ "-" }}</template>
        </template>

        <template #cell(EXE)="data">
          <template v-if="data.value === '-'"> {{ data.value}}</template>
          <template v-else-if="data.value!==''">
            <div v-if="data.item.isCombined">
              <div class="combined-line">
                {{ getMainValue(data.item, 'EXE') }}
              </div>
              <div class="combined-details">
                <div v-for="(op, index) in getFilteredDetails(data.item, 'EXE')" :key="'op-'+index">
                  {{ op.ttc }}€ - {{ op.name }}
                </div>
              </div>
            </div>
            <span v-else>
              {{ data.value === 0 ? '-' : data.value + ' €' }}
            </span>
          </template>
        </template>
        <template #cell(difference)="data">
          <template v-if="data.value === '-'"> {{ '-' }}</template>
          <template v-else-if="data.value === 0"> {{ '0 %' }}</template>
          <template v-else-if="data.value < 0">
            <div :class="data.item.charge ? 'main-green-color' : ''" class="bold-text">
              {{ data.value + " %" }}
            </div>
          </template>
          <template v-else-if="data.value!==''">
            <div :class="data.item.charge ? 'main-red-color' : ''" class="bold-text">
              {{ "+ " + data.value + " %" }}
            </div>
          </template>
        </template>

      </b-table>
    </div>

    <div>
      <b-table id="table-lots" :fields="tableFieldsLotsCustom"
               :items="itemsLots"
               :tbody-tr-class="rowClass"
               :thead-class="'row-header'"
               borderless
               class="light-border"
               striped>

        <template #[`head(${field.key})`]="{ label }" v-for="field in tableFieldsLotsCustom">
          <div @click="toggleExtraFieldsLots(field.key)" class="cursor-pointer label-primary d-flex" v-if="label && (!label.startsWith('TTC') && !label.startsWith('HT') && !label.startsWith('Différence'))"  :key="field.key">
            <div style="line-height: 2.2">{{ label }}</div>
            <caret-down-icon v-if="!field.isDetailVisible" />
            <caret-up-icon v-if="field.isDetailVisible" />
          </div>
          <span v-else class="label-primary" style="line-height: 2.2">
             {{ label }}
          </span>
        </template>

        <template #cell(lot)="data">
          {{ $t(data.value) }}
        </template>

        <template #cell()="data">
          <template v-if="data.value === '-'"> {{ data.value }}</template>
          <template v-else-if="data.value!==''"> {{ data.value + " €" }}</template>
          <template v-else-if="!data.value && !data.item.hasOwnProperty('status')"> {{ "-" }}</template>
          <template v-else-if="!data.value && data.item.hasOwnProperty('status') && data.item.status==='total-primary'"> {{ "-" }}</template>
        </template>

        <template #cell(simulation)="data">
          <template v-if="data.value === '-'"> {{ data.value }}</template>
          <template v-else-if="data.value!==''"> {{ data.value === 0 ? '-' : data.value + ' €' }}</template>
        </template>
        <template #cell(AVP)="data">
          <template v-if="data.value === '-'"> {{ data.value}}</template>
          <template v-else-if="data.value!==''">
            <div v-if="data.item.isCombined">
              <div class="combined-line">
                {{ getMainValue(data.item, 'AVP') }}
              </div>
              <div class="combined-details">
                <div v-for="(op, index) in getFilteredDetails(data.item, 'AVP')" :key="'op-'+index">
                  {{ op.ttc }}€ - {{ op.name }}
                </div>
              </div>
            </div>
            <span v-else>
              {{ data.value === 0 ? '-' : data.value + ' €' }}
            </span>
          </template>
        </template>
        <template #cell(EXE)="data">
          <template v-if="data.value === '-'"> {{ data.value}}</template>
          <template v-else-if="data.value!==''">
            <div v-if="data.item.isCombined">
              <div class="combined-line">
                {{ getMainValue(data.item, 'EXE') }}
              </div>
              <div class="combined-details">
                <div v-for="(op, index) in getFilteredDetails(data.item, 'EXE')" :key="'op-'+index">
                  {{ op.ttc }}€ - {{ op.name }}
                </div>
              </div>
            </div>
            <span v-else>
              {{ data.value === 0 ? '-' : data.value + ' €' }}
            </span>
          </template>
        </template>
        <template #cell(difference)="data">
          <template v-if="data.value === '-'"> {{ '-' }}</template>
          <template v-else-if="data.value === 0"> {{ '0 %' }}</template>
          <template v-else-if="data.value < 0">
            <div :class="data.item.vente ? 'main-red-color' : ''" class="bold-text">
              {{ data.value + " %" }}
            </div>
          </template>
          <template v-else-if="data.value!==''">
            <div :class="data.item.vente ? 'main-green-color' : ''" class="bold-text">
              {{ "+ " + data.value + " %" }}
            </div>
          </template>
        </template>
      </b-table>
    </div>

    <div>
      <b-table id="table-global" :fields="tableFieldsGlobal"
               :items="itemsGlobal"
               :tbody-tr-class="rowClass"
               :thead-class="'row-header'"
               borderless
               class="light-border"
               striped>
        <template #cell(nom)="data">
          {{ $t(data.value) }}
        </template>
        <template #cell(simulation)="data">
          <template v-if="data.value === '-'"> {{ data.value }}</template>
          <template v-else-if="data.value!==''"> {{ data.value === 0 ? '-' : data.value + ' €' }}</template>
        </template>
        <template #cell(AVP)="data">
          <template v-if="data.value === '-'"> {{ data.value }}</template>
          <template v-else-if="data.value!==''"> {{ data.value === 0 ? '-' : data.value + ' €' }}</template>
        </template>
        <template #cell(EXE)="data">
          <template v-if="data.value === '-'"> {{ data.value }}</template>
          <template v-else-if="data.value!==''"> {{ data.value === 0 ? '-' : data.value + ' €' }}</template>
        </template>
        <template #cell(difference)="data">
          <template v-if="data.value === '-'"> {{ '-' }}</template>
          <template v-else-if="data.value === 0"> {{ '0 %' }}</template>
          <template v-else-if="data.value < 0">
            <div v-if="data.item.charge" class="bold-text main-green-color">
              {{ data.value + " %" }}
            </div>
            <div v-else-if="data.item.vente" class="bold-text main-red-color">
              {{ data.value + " %" }}
            </div>
            <div v-else>
              {{ data.value + " %" }}
            </div>
          </template>
          <template v-else-if="data.value!==''">
            <div v-if="data.item.charge" class="bold-text main-red-color">
              {{ "+ " + data.value + " %" }}
            </div>
            <div v-else-if="data.item.vente" class="bold-text main-green-color">
              {{ "+ " + data.value + " %" }}
            </div>
            <div v-else>
              {{ "+ " + data.value + " %" }}
            </div>
          </template>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";
import BackArrow from "../../../components/b122/BackArrow.vue";

export default {
  name: "OperationShowAnalyse",
  components: {BackArrow},

  data() {
    return {
      showExtraFields: {},
      operationId: Number(this.$route.params.operationId),
      simulationId: Number(this.$route.params.simulationId) || null,
      isLoading: false,
      operationName: null,
      extraFields: [
        { key: 'ht_sim', label: 'HT'},
        { key: 'tva_sim', label: 'Simulation \nTVA'},
        { key: 'ttc_sim', label: 'TTC'},
        { key: 'ht_avp', label: 'HT'},
        { key: 'tva_avp', label: 'Bilan AVP \nTVA'},
        { key: 'ttc_avp', label: 'TTC'},
        { key: 'ht_exe', label: 'HT'},
        { key: 'tva_exe', label: 'Bilan EXE \nTVA'},
        { key: 'ttc_exe', label: 'TTC' },
      ],

      tableFields : [],
      tableFieldsCharges: [
        {label: '', key: 'type',subgroupKeys: [], thStyle: {width: "15%"}},
        {label: 'Simulation', key: 'simulation', thStyle: {width: "15%"},   subgroupKeys: ['ht_sim','tva_sim','ttc_sim'],isDetailVisible: false},
        {label: 'Bilan AVP', key: 'AVP', thStyle: {width: "15%"}, subgroupKeys: ['ht_avp','tva_avp', 'ttc_avp'],isDetailVisible: false},
        {label: 'Bilan EXE', key: 'EXE', thStyle: {width: "15%"}, subgroupKeys: ['ht_exe','tva_exe', 'ttc_exe'],isDetailVisible: false},
        {label: 'Différence', key: 'difference', thStyle: {width: "15%"},subgroupKeys: []},
      ],
      itemsCharges: [],

      tableFieldsLotsCustom : [],
      tableFieldsLots: [
        {label: 'Lot', key: 'lot', thStyle: {width: "15%"}},
        {label: 'Simulation', key: 'simulation',thStyle: {width: "15%"},   subgroupKeys: ['ht_sim','tva_sim','ttc_sim'],isDetailVisible: false},
        {label: 'Bilan AVP', key: 'AVP', thStyle: {width: "15%"}, subgroupKeys: ['ht_avp','tva_avp', 'ttc_avp'],isDetailVisible: false},
        {label: 'Bilan EXE', key: 'EXE', thStyle: {width: "15%"}, subgroupKeys: ['ht_exe','tva_exe', 'ttc_exe'],isDetailVisible: false},
        {label: 'Différence', key: 'difference', thStyle: {width: "15%"}},
      ],
      itemsLots: [],

      tableFieldsGlobal: [
        {label: 'Nom', key: 'nom',  thStyle: {width: "15%"}},
        {label: 'Simulation', key: 'simulation', thStyle: {width: "15%"}},
        {label: 'Bilan AVP', key: 'AVP', thStyle: {width: "15%"}},
        {label: 'Bilan EXE', key: 'EXE', thStyle: {width: "15%"}},
        {label: 'Différence', key: 'difference', thStyle: {width: "15%"}},
      ],
      itemsGlobal: [],
      showTooltip: null,
    }
  },

  async mounted() {
    if(this.operationId){
      await this.fetchOperation()
    }
    this.isLoading = true
    this.tableFields = [...this.tableFieldsCharges];
    this.tableFieldsLotsCustom = [...this.tableFieldsLots];
    await this.fetchData()
    this.isLoading = false
    // Call hasSimulation after all data is fetched to ensure simulation column is shown correctly
    this.hasSimulation()
  },

  methods: {

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operationName = response.data.name
          // If simulationId is not set from route params, try to get it from operation data
          if ((!this.simulationId || isNaN(this.simulationId)) && response.data.simulation) {
            this.simulationId = response.data.simulation.id
          }
        })
    },

    hasSimulation() {
      var state = !isNaN(this.simulationId) && this.simulationId !== undefined
      if (!state){
        this.tableFields = this.tableFields.filter(f => f.key !== 'simulation')
        this.tableFieldsLotsCustom = this.tableFieldsLotsCustom.filter(f => f.key !== 'simulation')
        this.tableFieldsGlobal = this.tableFieldsGlobal.filter(f => f.key !== 'simulation')
      }
    },

    toggleExtraFieldsCharges(column) {
      const colIndex = this.tableFields.findIndex(f => f.key === column);
      if (colIndex === -1) return;

      this.tableFields[colIndex].isDetailVisible = !this.tableFields[colIndex].isDetailVisible;

      if (this.tableFields[colIndex].isDetailVisible) {
        const removed = this.tableFields.splice(colIndex, 1)[0];
        const newColumns = removed.subgroupKeys.map(subKey => {
          const extraField = this.extraFields.find(extra => extra.key === subKey);
          const width = extraField.label.includes('TVA') ? '8%':'8%'
          return {
            label: extraField.label,
            key: `${subKey}`,
            thStyle: { width: width },
            isDetailVisible: true
          };
        });

        this.tableFields.splice(colIndex, 0, ...newColumns);
      } else {
        const suffix = column.slice(-3);
        this.tableFields = this.tableFields.filter(f => !f.key.includes(suffix));

        const newKey = suffix === 'sim' ? 'simulation' : suffix.toUpperCase()
        this.tableFields.splice(colIndex-1, 0, {
          ...this.tableFieldsCharges.find(f => f.key === newKey),
          isDetailVisible: false
        });
      }

      this.tableFields = [...this.tableFields];
    },

    toggleExtraFieldsLots(column) {
      const colIndex = this.tableFieldsLotsCustom.findIndex(f => f.key === column);
      if (colIndex === -1) return;

      this.tableFieldsLotsCustom[colIndex].isDetailVisible = !this.tableFieldsLotsCustom[colIndex].isDetailVisible;

      if (this.tableFieldsLotsCustom[colIndex].isDetailVisible) {
        const removed = this.tableFieldsLotsCustom.splice(colIndex, 1)[0];
        const newColumns = removed.subgroupKeys.map(subKey => {
          const extraField = this.extraFields.find(extra => extra.key === subKey);
          const width = extraField.label.includes('TVA') ? '8%':'8%'
          return {
            label: extraField.label,
            key: `${subKey}`,
            thStyle: { width: width },
            isDetailVisible: true
          };
        });

        this.tableFieldsLotsCustom.splice(colIndex, 0, ...newColumns);
      } else {
        const suffix = column.slice(-3);
        this.tableFieldsLotsCustom = this.tableFieldsLotsCustom.filter(f => !f.key.includes(suffix));

        const newKey = suffix === 'sim' ? 'simulation' : suffix.toUpperCase()
        this.tableFieldsLotsCustom.splice(colIndex-1, 0, {
          ...this.tableFieldsLots.find(f => f.key === newKey),
          isDetailVisible: false
        });
      }

      this.tableFieldsLotsCustom = [...this.tableFieldsLotsCustom];
    },


    async fetchData() {
      await this.fetchAnalyseData()
    },

    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'title-section-margin') return 'row-title-section row-margin'
      if (item.status === 'title-section') return 'row-title-section'
      else if (item.status === 'total-primary') return 'row-total-primary'
      else if (item.status === 'total-grey') return 'row-total-grey'
      else if (item.status === 'subtitle') return 'bold-text main-red-color'
    },

    async fetchAnalyseData() {
      api
        .get(`/operationBilan/getAnalyseData/${this.operationId}`)
        .then(response => {
          this.itemsCharges = response.data['itemsCharges']
          this.itemsCharges =  this.itemsCharges.map(item => ({
            ...item,
            _showDetails: false, // Ajoutez cette propriété pour gérer l'affichage des détails
            details: { // Ajoutez les détails HT, TVA, TTC ici
              ht: 1,
              tva: 2,
              ttc: 3,
              // Autres détails pour AVP et EXE si nécessaire
            }
          })),
          this.itemsLots = response.data['itemsLots']
          this.itemsGlobal = response.data['itemsGlobal']
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    goToSimulation() {
      this.$router.push({
        name: 'SimulationShow',
        params: {
          simulationId: this.simulationId
        }
      })
    },

    getUniqueItems(items) {
      const seen = new Set();
      return items.filter(item => {
        const duplicate = seen.has(item.name);
        seen.add(item.name);
        return !duplicate;
      });
    },

    handleMouseEnter(index) {
      this.showTooltip = index;
    },
    handleMouseLeave() {
      this.showTooltip = null;
    },

    getMainValue(item, column) {
      if (!item.combinedDetails || !item.combinedDetails.operation) return item.value || '-'

      // Filter operations by column first
      const filteredOperations = item.combinedDetails.operation.filter(op => {
        if (column === 'AVP') {
          return op.bilanType === 'AVP'
        }
        if (column === 'EXE') {
          return op.bilanType === 'EXE'
        }
        return true
      })

      const mainOperation = filteredOperations.find(op =>
        op.name.toLowerCase() === item.type.toLowerCase()
      )

      if (!mainOperation) return item.value || '-'

      return mainOperation.ttc === 0 ? '-' : mainOperation.ttc + ' €'
    },

    getFilteredDetails(item, column) {
      if (!item.combinedDetails || !item.combinedDetails.operation) return []

      return item.combinedDetails.operation.filter(op => {
        // Exclude the main operation (the one with the same name as the item.type)
        if (op.name.toLowerCase() === item.type.toLowerCase()) {
          return false
        }

        // Si nous sommes dans la colonne AVP, ne montrer que les opérations AVP
        if (column === 'AVP') {
          return op.bilanType === 'AVP'
        }

        // Si nous sommes dans la colonne EXE, ne montrer que les opérations EXE
        if (column === 'EXE') {
          return op.bilanType === 'EXE'
        }

        return true
      })
    },
  }
}
</script>

<style scoped>
.label-primary {
  background-color: var(--main-white) !important;
  color: var(--main-color);
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}


.combined-line {
  font-weight: bold;
}

.loue-color {
  color: #6d84c4;
}



</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowAnalyse.vue